import { mutate } from "swr"
import useResource from "./useResource"

import { pluralize } from "web/services/inflector"

export default function useAccountValues({
  subjectType,
  subjectId,
  isTopicRecord,
}) {
  const url = isTopicRecord
    ? `/topics/records/${subjectId}/account_values`
    : `${pluralize(subjectType)}/${subjectId}/account_values`

  // hooks can't be called conditionally, so we use
  // subjectId = null to signify that request is not needed
  const key = subjectId === null ? null : url

  const response = useResource({ key })
  const [data] = response

  function localUpdate(fieldName, value) {
    const newData = { ...data, [fieldName]: value }
    mutate(key, newData, false)
  }

  return [data, localUpdate]
}
